import { AdditionalFields } from '../domain/entities/inspirationalTemplate';
import { INSPIRATIONAL_TEMPLATE_MAP as EN_MAP } from './inspirationalTemplateMap.en';

export const INSPIRATIONAL_TEMPLATE_MAP: Record<string, AdditionalFields> = {
  'b991864c-cd05-498d-85e2-03459fdeb6ec': {
    backgroundColor: '#F3FFE0',
    shortDescription:
      "Inspirez-vous de ce site d'une seule page qui suspend le défilement et bouleverse les attentes.",
    features: [
      'Vidéo transparente',
      'Animation de survol',
      'Texte défilant',
      'Code personnalisé',
      'Grille CSS',
      `Bibliothèque d'actifs à télécharger`,
    ],
    inspirationalAssets:
      EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].inspirationalAssets,
  },
  'd674b741-2412-4260-af3f-c5f0e964fcd5': {
    backgroundColor: '#F4EDFF',
    shortDescription:
      "Nourrissez votre imagination et préparez-vous au lancement avec ce site d'exploration spatiale.",
    features: [
      'Animation de défilement',
      'Animation en boucle',
      'Défilement horizontal',
      'Effets de survol',
      'CSS personnalisé',
    ],
    inspirationalAssets:
      EN_MAP['d674b741-2412-4260-af3f-c5f0e964fcd5'].inspirationalAssets,
  },
  '8de718ac-8cc4-4b69-88ab-4d92920c37a2': {
    backgroundColor: '#FFE8E4',
    shortDescription:
      'Démarquez-vous et ajoutez du mouvement avec des textes défilants dynamiques.',
    features: [
      `Texte défilant`,
      `Animation de défilement`,
      `Animation en boucle`,
      `Animation d'entrée`,
      `Effets de défilement d'arrière-plan`,
      `Grille CSS`,
    ],
    inspirationalAssets:
      EN_MAP['8de718ac-8cc4-4b69-88ab-4d92920c37a2'].inspirationalAssets,
  },
  '50d5ca42-112a-466a-aca2-fd8bc927a965': {
    backgroundColor: '#E2FFE2',
    shortDescription:
      "Inspirez-vous des effets et des animations de défilement qui captent l'attention des lecteurs sur le message de cette organisation à but non lucratif.",
    features: [
      'Animation de défilement',
      'Animation en boucle',
      `Animation d'entrée`,
      'Vidéo transparente',
      'Grille CSS',
      'Pile',
    ],
    inspirationalAssets:
      EN_MAP['50d5ca42-112a-466a-aca2-fd8bc927a965'].inspirationalAssets,
  },
  '31ec1ed2-9432-46e2-8175-5e4ccab9b5b9': {
    backgroundColor: '#FFE6F1',
    shortDescription:
      'Donnez vie à des faits, des statistiques et des chiffres grâce au scrollytelling.',
    features: [
      'Animation de défilement',
      'Animation en boucle',
      `Animation d'entrée`,
      'Texte défilant',
      `Dégradé d'arrière-plan`,
      `Effets de défilement d'arrière-plan`,
    ],
    inspirationalAssets:
      EN_MAP['31ec1ed2-9432-46e2-8175-5e4ccab9b5b9'].inspirationalAssets,
  },
  '498fe8fb-46ba-45a5-9346-3bb5b1c9f61c': {
    backgroundColor: '#E6F2FF',
    shortDescription:
      "Percez les mystères du zodiaque et laissez ce site d'astrologie devenir la muse de votre prochain projet.",
    features: [
      'Effets de souris',
      'Position collante',
      'Défilement horizontal',
      'Animation de défilement',
      'Code personnalisé',
    ],
    inspirationalAssets:
      EN_MAP['498fe8fb-46ba-45a5-9346-3bb5b1c9f61c'].inspirationalAssets,
  },
};
